


























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import SuporteProcedimentosApenasHospitalDiaStore from '@/components/Suporte/Store/SuporteProcedimentosApenasHospitalDiaStore'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalSuporteProcedimentoApenasHospitalDia extends Vue {
  loadSaveOrUpdateProcedimentoApenasHospitalDia: boolean = false

  get getSuporteProcedimentosApenasHospitalDiaStore() {
    return getModule(SuporteProcedimentosApenasHospitalDiaStore, this.$store)
  }

  get loadingSaveOrUpdateProcedimentoApenasHospitalDia() {
    return this.loadSaveOrUpdateProcedimentoApenasHospitalDia
  }

  set loadingSaveOrUpdateProcedimentoApenasHospitalDia(value: boolean) {
    this.loadSaveOrUpdateProcedimentoApenasHospitalDia = value
  }

  get showModalProcedimentoApenasHospitalDia() {
    return this.getSuporteProcedimentosApenasHospitalDiaStore.modal.procedimentoApenasHospitalDia
  }

  set showModalProcedimentoApenasHospitalDia(value: boolean) {
    this.getSuporteProcedimentosApenasHospitalDiaStore.setModal({ name: 'procedimentoApenasHospitalDia', value })
  }

  get convenios() {
    return this.getSuporteProcedimentosApenasHospitalDiaStore.convenios
  }

  get procedimentos() {
    return this.getSuporteProcedimentosApenasHospitalDiaStore.procedimentos
  }

  get procedimentoApenasHospitalDia() {
    return this.getSuporteProcedimentosApenasHospitalDiaStore.procedimentoApenasHospitalDia
  }

  $refs!: {
    formProcedimentoApenasHospitalDia: any
  }

  formProcedimentoApenasHospitalDiaRules: any = {
    valid: true,
    procedimentoId: [(v: any) => !!v || 'Campo obrigatório.'],
    convenioId: [(v: any) => !!v || 'Campo obrigatório.'],
    hospitalDia: [(v: any) => ![null, undefined].includes(v) || 'Campo obrigatório.'],
  }

  async saveOrUpdateProcedimentoApenasHospitalDia() {
    this.loadingSaveOrUpdateProcedimentoApenasHospitalDia = true

    if (this.$refs.formProcedimentoApenasHospitalDia.validate()) {
      const { mode } = this.getSuporteProcedimentosApenasHospitalDiaStore

      const response = await this.getSuporteProcedimentosApenasHospitalDiaStore.upsertProcedimentoApenasHospitalDia()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Procedimento ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getSuporteProcedimentosApenasHospitalDiaStore.getProcedimentosApenasHospitalDiaPagedSearch(this.getSuporteProcedimentosApenasHospitalDiaStore.paginationProcedimentosApenasHospitalDia)
        this.showModalProcedimentoApenasHospitalDia = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o procedimento ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateProcedimentoApenasHospitalDia = false
  }

  @Watch('showModalProcedimentoApenasHospitalDia')
  onChangeshowModalProcedimentoApenasHospitalDia(value: boolean) {
    if (!value) {
      this.getSuporteProcedimentosApenasHospitalDiaStore.clearProcedimentoApenasHospitalDia()
      this.getSuporteProcedimentosApenasHospitalDiaStore.clearProcedimentos()
      this.getSuporteProcedimentosApenasHospitalDiaStore.clearConvenios()
      this.getSuporteProcedimentosApenasHospitalDiaStore.setMode({ mode: 'CREATE' })
      this.$refs.formProcedimentoApenasHospitalDia.resetValidation()
    }
  }
}
